export default {
    ENV: process.env.REACT_APP_DEPLOY_ENV || "DEV",
    IS_DEVELOPMENT: process.env.NODE_ENV === "development"
}